<template>
  <div id='diagram-buton' class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item :click="notices" eventType='addDevice' v-if="addDeviceBtn" :tooltipText='$t("Topo.devAdd")' prefixIcon='icon hero-icon hero-icon-add'></e-item>
        <e-item :click="notices" eventType='editDevice' :tooltipText='$t("Topo.editDev")' prefixIcon='icon hero-icon hero-icon-edit'></e-item>
        <e-item :click="notices" eventType='delDevice' v-if="delDeviceBtn" :tooltipText='$t("Topo.delDev")' prefixIcon='icon hero-icon hero-icon-remove'></e-item>
        <e-item :click="notices" eventType='upGrade'  v-if="upGradeBtn" :tooltipText='$t("Software.updataOper")' prefixIcon='icon hero-icon hero-icon-upload'></e-item>
        <e-item :click="notices" eventType='downGrade' v-if="downGradeBtn" :tooltipText='$t("Software.rollbackOper")' prefixIcon='icon hero-icon hero-icon-download'></e-item>
        <e-item :click="notices" eventType='synVersion' v-if="synVersionBtn" :tooltipText='$t("DeployManagement.synVersion")' prefixIcon='icon hero-icon hero-icon-synchronize'></e-item>
        <e-item :click="notices" eventType='patchUpgrade' v-if="patchUpgradeBtn" :tooltipText='$t("DeployManagement.patchUpgrade")' prefixIcon='icon hero-icon hero-icon-business-operation'></e-item>
        <!--<e-item :click="notices" eventType='changeGPS' v-if="changeGPSBtn" :tooltipText='$t("DeployManagement.changeGPS")' prefixIcon='icon hero-icon hero-icon-region'></e-item>-->
        <e-item :click="notices" eventType='import' v-if="importBtn" :tooltipText='$t("System.batchImport")' prefixIcon='icon hero-icon hero-icon-upload'></e-item>
        <e-item :click="notices" eventType='export' v-if="exportBtn" :tooltipText='$t("System.batchExport")' prefixIcon='icon hero-icon hero-icon-export'></e-item>
        <e-item :click="notices" eventType='exportAll' v-if="exportBtn" :tooltipText='$t("Alarm.exportAll")' prefixIcon='icon hero-icon hero-icon-batch-export'></e-item>     
      </e-items>
    </ejs-toolbar>
    <div class='h-inputBox'>
      <ejs-textbox :placeholder='$t("Topo.pleaseEnterDeviceName")' v-model='searchValue' @keydown.native.enter='searchName'></ejs-textbox>
    </div>
     <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
        <template v-slot:dialog-content>
          <AddDialog ref='addObj'></AddDialog>
        </template>
      </CustomDialog>
     <CustomDialog ref='resultTable' :element='resultTable.element' :styles='resultTable.styles1'>
        <template v-slot:dialog-content>
          <ImportResultTable ref='resultObj'></ImportResultTable>
        </template>
      </CustomDialog>
  </div>
</template>

<script>
import AddDialog from '../../../../components/system/ConfigInEx/addDialog';
import ImportResultTable from '../../../../components/system/ConfigInEx/importResultTable';
import CustomDialog from '../../../../components/common/CustomDialog';
import { EventBus } from '../../../../plugins/eventBus';
import bus from '../../../../components/system/bus.js';
let fileName ="";
  export default {
    mounted() {
    fileName ="";
    console.log("=====fileName===",fileName);
     bus.$on('fileName', (neNode) => {
           console.log("=====neNode===",neNode);
       fileName = neNode;
    });

  },
  components: {
    AddDialog,
    CustomDialog,
    ImportResultTable
  },
    name: 'BSButton',
    props: {
      addDeviceBtn: { type: Boolean, default: false },
      delDeviceBtn: { type: Boolean, default: false },
      upGradeBtn: { type: Boolean, default: false },
      downGradeBtn: { type: Boolean, default: false },
      synVersionBtn: { type: Boolean, default: false },
      patchUpgradeBtn: { type: Boolean, default: false },
      changeGPSBtn: { type: Boolean, default: false },
      importBtn: { type: Boolean, default: false },
      exportBtn: { type: Boolean, default: false },
    },
    data(){
      return{
        searchValue: '',
        keywordsInput: true,

      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('System.analyiseButton') } },
          ],
          title: this.$t('System.uploadText')
        },
      },
      
      resultTable: {
        styles: {
          width: '1210px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '900px',
          height: '600px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.closeResult, buttonModel: { content: this.$t('Pm.disable') } },
          ],
          title: this.$t('SubscriberIms.operResult')
        },
      },

      }
    },
    methods: {
      notices(args) {
        this.$emit('notice', args.item.eventType);
      },
      searchName() {
        this.$emit('search', this.searchValue);
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      addDialog() {
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
        closeResult(){
         this.$refs.resultTable.clear();
         this.$refs.resultTable.close();
    },
    dialogHide() {
      if(fileName ==""||fileName == undefined){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
           return;
      }
      let index = fileName.lastIndexOf(".");
      let fileType = fileName.substring(index+1).toLocaleLowerCase();

      if(fileType !='xlsx'){
        this.eventEmit('warning', this.$t('System.fileTypeError'));
        return;
      }
    
      //增加文件解析并返回结果部分，非常之复杂
      if(this.uploadProps.status == 1){
       const url = '/lte/ems/env/importBatchNe';
        const param = {
          fileName: fileName
        };
        this.$loading.showLoadding(this.$t("SubscriberIms.waitTip"));
        this.$axios.post(url, param).then(res => {

          if (res.data.errorCode === '2701') {
            EventBus.$emit('toast', {type: 'warn', content: res.data.errorString});
            this.$loading.hideLoadding();
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'warn', content:this.$t('System.importSuccess') });
            fileName = "";
            this.$refs.resultTable.show();
            this.$refs.resultObj.setData(res.data.resultVal);
                      this.$emit('search', this.searchValue);
                      this.$emit('getDeviceListData');
            this.$loading.hideLoadding();
          }
        });

         this.$refs.upload.clear();
         this.$refs.upload.close();
      }else{
          this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('DeployManagement.tips_cancelUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
                this.$refs.upload.clear();
                this.$refs.upload.close();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
    }
    },
    beforeDestroy() {
     bus.$off('fileName');
  }
  }
</script>

